import { Card, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BrowserDefault } from "../../../../Constant";
import { BROWSER_DEFAULT } from "../../../../Data/FormControl/FormValidation";
import { BrowserDefaultsCardBody } from "./BrowserDefaultsCardBody";

const BrowserDefaults = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={BrowserDefault} span={BROWSER_DEFAULT} />
        <BrowserDefaultsCardBody/>
      </Card>
    </Col>
  );
};

export default BrowserDefaults;
